'use client';

import { Alert, rem } from '@mantine/core';
import { type JSX, useMemo, type SVGProps } from 'react';
import AlertIcon from '@/assets/icons/warning-diamond-red-icon.svg';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

type BookingAlertProps = {
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  title?: string;
  description?: string;
};

export default function BookingAlert({
  icon: Icon,
  title,
  description,
}: BookingAlertProps) {
  const { alertBooking } = useBookingStore((state) => state);

  const errorData = useMemo(() => {
    return {
      title: title ?? alertBooking?.title,
      description: description ?? alertBooking?.description,
    };
  }, [alertBooking, description, title]);

  if (!alertBooking && !errorData?.title && !errorData?.description) {
    return null;
  }

  return (
    <Alert
      variant="default"
      color="red"
      title={errorData?.title}
      icon={Icon ? <Icon /> : <AlertIcon />}
      styles={{
        root: {
          borderRadius: rem(12),
          padding: rem(12),
          border: 'transparent',
          backgroundColor: 'var(--mantine-color-red-1)',
        },
        icon: {
          marginRight: rem(8),
        },
        title: {
          color: 'var(--mantine-color-neutral-7)',
          fontSize: rem(14),
          lineHeight: rem(20),
          fontWeight: 700,
        },
        message: {
          color: 'var(--mantine-color-neutral-6)',
          fontSize: rem(14),
          lineHeight: rem(20),
          fontWeight: 500,
        },
        body: {
          gap: rem(4),
        },
      }}
    >
      {errorData?.description ?? ''}
    </Alert>
  );
}
